/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteBannerResponse } from '../../models/delete-banner-response';

export interface AdminServiceDeleteBanner$Params {
  bannerId: string;
}

export function adminServiceDeleteBanner(http: HttpClient, rootUrl: string, params: AdminServiceDeleteBanner$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteBannerResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceDeleteBanner.PATH, 'delete');
  if (params) {
    rb.path('bannerId', params.bannerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteBannerResponse>;
    })
  );
}

adminServiceDeleteBanner.PATH = '/api/v3/gateway/admin/banner/{bannerId}';
